module.exports = __webpack_public_path__ + "static/media/icon_10.e9c2d6b7.png";